<template>
  <div v-show="!this.isShow.isLDShow" id="music" class="music" @click="toggleMusic">
    <div class="cloud">
      <div class="note" :class="isPlay ? 'rotating' : ''"></div>
    </div>
    <audio :src="musicPlayed" id="myMusic" preload="preload" loop></audio>
    <audio :src="musicAfterURL" id="preMusic" preload="preload"></audio>
  </div>
</template>

<script>
export default {
  name: 'MusicPlayer',
  props: {
    isShow: {
      type: Object
    },
    mState: {
      type: Boolean
    }
  },
  data () {
    return {
      musicBeforeURL: 'https://www.jiandoukeji.com/h5/2018/jdzq/mp3/music-before2.mp3',
      musicAfterURL: 'https://www.jiandoukeji.com/h5/2018/jdzq/mp3/music-after.mp3',
      isPlay: true
    }
  },
  mounted () {
    this.audioPlay()
  },
  methods: {
    toggleMusic () {
      if (this.isPlay) {
        this.audioPause()
      } else {
        this.audioPlay()
      }
      this.isPlay = !this.isPlay
    },
    audioPlay () {
      let audio = document.getElementById('myMusic')
      audio.play()
      document.addEventListener('WeixinJSBridgeReady', function () {
        audio.play()
      }, false)
    },
    audioPause () {
      let audio = document.getElementById('myMusic')
      audio.pause()
      document.addEventListener('WeixinJSBridgeReady', function () {
        audio.pause()
      }, false)
    }
  },
  computed: {
    musicPlayed () {
      if (this.mState & this.isPlay) {
        setTimeout(() => {
          this.audioPlay()
        }, 200)
        return this.musicAfterURL
      } else {
        return this.musicBeforeURL
      }
    }
  }
}
</script>

<style lang="less" scoped>
.music {
  position: absolute;
  right: .5rem;
  top: .5rem;
  z-index: 10;
  margin-left: 1rem;
  margin-bottom: 1rem;
  width: 2.75rem /* 44/16 */;
  height: 2.25rem /* 36/16 */;
  .cloud {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2.03125rem /* 32.5/16 */;
    height: 2.03125rem /* 32.5/16 */;
    .note {
      width: 2.03125rem /* 32.5/16 */;
      height: 2.03125rem /* 32.5/16 */;
      background-image: url(./music.png);
      background-size: 100% 100%;
    }
    .rotating {
      animation: rotate-music 2s linear infinite;
    }
  }
  @keyframes rotate-music {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
